var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageLink)?_c('v-menu',{attrs:{"offset-y":"","open-on-hover":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mb-1 ml-1"},'v-icon',attrs,false),on),[_vm._v("\n      mdi-information-outline\n    ")])]}}],null,false,1445408337)},[_c('v-card',{staticClass:"pa-3"},[_c('v-img',{attrs:{"src":_vm.imageLink,"max-width":"500px"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }